import {guid,type,copy} from '../util/util';
import $ from 'webpack-zepto';
/**
 * @export BaseStore
 * @class BaseStore
 * @desc store 的基类，提供通用功能例如重设，方法统一访问接口，快照还原 等功能
 * @author lei.you
 * @date 2018/2/8
 * */
class BaseStore{
    static STATE_INIT="STATE_INIT";
    static mapping={};
    static id =  Symbol();
    /**
     * @desc 生成baseStore 实例
     * @param {object} config 配置文件
     * @return {BaseStore} baseStore 实例
     * */
    static getInstance(config){
        //debugger
        var baseStore=new BaseStore(config);
        baseStore.init();
        return baseStore;
    }
    /**
     * @desc 获取对应的store 实例的mapping
     * @param {string} guid
     * @return {BaseStore} baseStore 实例
     * */
    static getStateMapping(guid){
        return BaseStore.mapping[guid];
    }
    /**
     * @constructor
     * @param {object} config 配置
     * */
    constructor(config){
        this.guid=guid.getGuid();

        config.state[BaseStore.id]=this.guid
        //config.state.id=this.guid;
        config.state.name=config.name;
        this.state=config.state;
        this.mutations=config.mutations;
        this.actions=config.actions;
        this.namespaced=config.namespaced||true;
        this.copyState={};
    }
    /**
     * @desc 初始化对象
     * */
    init(){
        //this._cloneState();
        BaseStore.mapping[this.guid]={}
        this.shoot(null,{key:BaseStore.STATE_INIT});
        if(this.mutations){
            this.mutations.reset=this.reset;
            this.mutations.restore=this.restore;
            this.mutations.shoot=this.shoot;
            this.mutations.mutation=this.mutation;
            this.mutations.removeAllPhotograph=this.removeAllPhotograph;
            this.mutations.removeAllPhotographByName=this.removePhotographByName;
        }
        if(this.actions){
            this.actions.action=this.action;
        }
        //BaseStore.mapping[this.guid]=this.copyState;

    }
    _cloneState(){
        var copyState=copy.deepcopy(this.state);
        return copyState;
    }

    /***
     *
     * @description :给状态拍照
     * @param{object} state 状态
     * @param{object} {key:''}  key  拍照指定的唯一名称
     *
     */
    shoot(state,data){
        var key = data.key;
        var copyState =copy.deepcopy(state||this.state)
        var stateMapping =BaseStore.getStateMapping(copyState[BaseStore.id]);
        stateMapping[key]=copyState;
        data.callbackData=copyState;
        //return copyState;
    }
    /***
     *
     * @description :清除所有的照片
     * @param{object} state 状态
     * @param{object} {key:''}  key  拍照指定的唯一名称
     *
     */
    removeAllPhotograph(state,data){
        //BaseStore.mapping[]
        var stateMapping =BaseStore.getStateMapping(state[BaseStore.id]);
        for(var key in stateMapping){
            stateMapping[key]={};
        }
    }
    /***
     *
     * @description :清除指定名称的照片
     * @param{object} state 状态
     * @param{object} {key:''}  key  照片名称
     *
     */
    removePhotographByName(state,data){
        var key = data.key;
        var stateMapping =BaseStore.getStateMapping(state[BaseStore.id]);
        stateMapping[data.key]={};

    }
    /***
     *
     * @description :还原到某一个指定名称的状态
     * @param{object} state 状态
     * @param{object} {key:''}  key  拍照指定的唯一名称
     *
     */
    restore(state,data){
        var key =data.key;
        var stateMapping = BaseStore.getStateMapping(state[BaseStore.id]);
        //return $.extend(true,state,stateMapping[key]);
        data.callbackData=$.extend(true,state,stateMapping[key]);
    }
    /***
     *
     * @description :清除状态设置，恢复最初状态
     * @param{object} state 状态
     * @param{object} {key:''}  key  拍照指定的唯一名称
     *
     */
    reset(state,data){
        //console.log(state.id)
        //this.state=BaseStore.copyState;
        var stateMapping = BaseStore.getStateMapping(state[BaseStore.id]);
        $.extend(true,state,stateMapping[BaseStore.STATE_INIT]);
    }
    mutation(state,params){
        if(type.isObject(params)){
            this.commit(state.name + '/' + params.name,params.value)
        }else if(type.isArray(params)){
            for (var i = 0; i < params.length; i++) {
                var obj = params[i];
                this.commit(state.name + '/' + obj.name,obj.value)
            }
        }
    }
    action(context,params){
        if(type.isObject(params)){
            this.dispatch(context.state.name + '/' + params.name,params.data)
        }else if(type.isArray(params)){
            for (var i = 0; i < params.length; i++) {
                var obj = params[i];
                this.dispatch(context.state.name + '/' + obj.name,obj.data)
            }
        }
    }

}
export default BaseStore;
